import { ensureActive17z6c489wymmv as ensureActive } from './Emitters.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../channels/Channels.common.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function emitAll(_this__u8e3s4, channel, $completion) {
  return emitAllImpl(_this__u8e3s4, channel, true, $completion);
}
function *_generator_emitAllImpl__caj84m(_this__u8e3s4, channel, consume, $completion) {
  ensureActive(_this__u8e3s4);
  var cause = null;
  try {
    var _iterator__ex2g4s = channel.u1();
    $l$loop: while (true) {
      var tmp = _iterator__ex2g4s.q1a($completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      if (!tmp) {
        break $l$loop;
      }
      var element = _iterator__ex2g4s.w1();
      var tmp_0 = _this__u8e3s4.s1d(element, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cause = e;
      throw e;
    } else {
      throw $p;
    }
  }
  finally {
    if (consume) {
      cancelConsumed(channel, cause);
    }
  }
  return Unit_instance;
}
function emitAllImpl(_this__u8e3s4, channel, consume, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_emitAllImpl__caj84m.bind(VOID, _this__u8e3s4, channel, consume), $completion);
}
//region block: exports
export {
  emitAll as emitAll3riqz9vrzwab0,
};
//endregion

//# sourceMappingURL=Channels.mjs.map
